
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporate-events",
      function () {
        return require("private-next-pages/corporate-events.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporate-events"])
      });
    }
  